import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
export default ({
  title,
  ...extra
}) => /*#__PURE__*/_jsxs("svg", {
  height: "50",
  width: "50",
  viewBox: "0 0 50 50",
  ...extra,
  children: [title, /*#__PURE__*/_jsx("path", {
    d: "M37.906.002H0v50h50V12.146L37.906.002zM31.2 3.56v17.936H12.702V3.56H31.2zm15.243 42.885H3.557V3.56h5.59v21.49h25.61V3.56h1.676l10.01 10.06v32.825z"
  }), /*#__PURE__*/_jsx("path", {
    d: "M29.675 20.022V5.082H19.41v14.89h10.265zM22.967 8.64h3.15v7.774h-3.15V8.64z"
  })]
});